module.exports = __webpack_public_path__ + "img/kf.8dca3d9d.png";